var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lh-1 pad30-lr pad15-tb text-center" }, [
    _c("div", { staticClass: "flex items-center justify-center radius5 img" }, [
      _c("img", {
        attrs: { src: _vm.detail.picUrl + "?imageView2/1/w/100/h/100" }
      })
    ]),
    _c("div", { staticClass: "gray3 name" }, [_vm._v(_vm._s(_vm.detail.name))]),
    _vm.detail.skuSpecsIndex
      ? _c("div", { staticClass: "gray9" }, [
          _vm._v(_vm._s(_vm.detail.skuSpecsIndex))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }